import { rootReducer, RootState } from './rootState';
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';

const windowIfDefined = typeof window === 'undefined' ? null : (window as any);
const composeEnhancers = (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export default function configureStore(initialState?: RootState) {
  // configure middlewares
  // const sagaMiddleware = createSagaMiddleware();
  const middlewares: any[] = [];

  if (process.env.NODE_ENV === 'development!') {
    middlewares.push(
      createLogger({
        collapsed: true,
        duration: true,
      })
    );
  }

  // compose enhancers
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  // create store
  const store = createStore(rootReducer, initialState!, enhancer);
  // sagaMiddleware.run(rootSaga);
  return store;
}



// WEBPACK FOOTER //
// ./src/store.tsx